import { render, staticRenderFns } from "./DealView.vue?vue&type=template&id=a33159c4"
import script from "./DealView.vue?vue&type=script&lang=js"
export * from "./DealView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports